module.exports = __webpack_public_path__ + "h5-static/img/button_circle@3x.51b713a5.png";